import classNames from 'classnames';
import { FC, memo } from 'react';

import { Skeleton } from '@gem/ui-kit';

import styles from './ImagePlaceholder.styles.m.css';

interface IImagePlaceholderProps {
  width?: number;
  height?: number;
  className?: string;
}

export const ImagePlaceholder: FC<IImagePlaceholderProps> = memo((props) => {
  const { width = 200, height = 100, className } = props;

  return (
    <Skeleton
      height={`${height}px`}
      width={`${width}px`}
      className={classNames(styles.container, className)}
    />
  );
});
